import { memo } from 'react';
import { AutocompleteInput, useRecordContext } from 'react-admin';
import { CategoryStatus } from '../../constants/Status';

export const AutocompleteStatus = memo((props) => {
  const { className, source } = props;
  const record = useRecordContext(props);
  const status = record[source];
  return (
    <AutocompleteInput
      className={className}
      source={source}
      label="Status"
      defaultValue={status}
      optionText="name"
      optionValue="id"
      choices={CategoryStatus}
    />
  );
});
